import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logoIscert from '../assets/logo-iscert.svg';
import {useAuth} from "../utils/authContext";
import {fetchCertificateDetails, getUserInfo} from "../services/userInfoService";
import {decodeCertificate} from "../utils/decodeCertificate";
import {LoadingPage} from "./LoadingPage";
import '../assets/iscert/css/iscert.css';


export const SelectCertificate = () => {
  const [certificates, setCertificates] = useState([]);
  const [userName, setUserName] = useState('');
  const [selectedCertificate, setSelectedCertificate] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { token } = useAuth();
  const [loading, setLoading] = useState(true);
  const ConditionalLoadingPage = LoadingPage;
  useEffect(() => {
    const fetchCertificates = async () => {
      try {
        const storedCertificates = JSON.parse(localStorage.getItem('enabledCertificates'));
        if (storedCertificates && storedCertificates.length > 0) {
          const certDetails = await Promise.all(
              storedCertificates.map(async (cert) => {
                const data = await fetchCertificateDetails(token, cert.id);
                const { notBefore, notAfter, serialNumber } = decodeCertificate(data.details.certificate);
                return {
                  id: cert.id,
                  title: serialNumber,
                  validity: `${notBefore.toLocaleDateString()} - ${notAfter.toLocaleDateString()}`
                };
              })
          );

          setCertificates(certDetails);
          const userInfo = await getUserInfo(token);
          setUserName(userInfo.name);
          if (certDetails.length > 0) {
            setSelectedCertificate(certDetails[0].id);
          }
        } else {
          navigate('/consent');
        }
      } catch (error) {
        console.error('Error fetching certificates:', error);
        navigate('/signer/signDocument', { state: { alertType: 'error', alertMessageKey: 'componentAlerts.error' } });
      }
      finally {
        setLoading(false); // Finalizar la carga
      }
    };

    fetchCertificates();
    const fetchUserInfo = async () => {
      try {
        const userInfo = await getUserInfo(token);
        setUserName(userInfo.name);
      } catch (error) {
        console.error('Error fetching user info:', error);
      }
    };

    fetchUserInfo();
  }, [navigate, token]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedCertificate) {
      localStorage.setItem('certificateId', selectedCertificate);
      navigate('/consent');
    } else {
      setError(t('selectCertificate.issue-detail-1'));
    }
  };

  const handleCancel = () => {
    navigate('/signer/signDocument');
  };

  if (certificates.length === 1) {
    localStorage.setItem('certificateId', certificates[0].id);
    navigate('/consent');
    return null;
  }

  if (loading) {
    return <ConditionalLoadingPage />;
  }
  return (
      <section id="cripto">
        <div className="brand-logo">
          <img className="img-fluid" src={logoIscert} alt="Logotipo iSCert" />
        </div>
        <form className="form-signin"  onSubmit={handleSubmit} style={{ boxSizing: 'content-box' }}>
          <h2 className="txt-small text-left">{t('selectCertificate.title')}</h2>
          <p className="txt-sub text-left">
            <span className="upper">{userName}, </span>{t('selectCertificate.detail-1')}
          </p>
          {certificates.map((cert) => (
            <div className="card-area" key={cert.id} style={{ textAlign: 'left' }}>
              <div className="form-group form-check abc-checkbox">
                <input
                  className="form-check-input"
                  id={`radio-${cert.id}`}
                  type="radio"
                  name="inlineRadioOptions"
                  value={cert.id}
                  checked={selectedCertificate === cert.id}
                  onChange={() => setSelectedCertificate(cert.id)}
                />
                <div className="card-content" style={{ fontSize: '0.9rem' }} >
                  <h4 className="title">Número de Serie:<br/>
                    {cert.title}</h4>
                  <span className="date">
                    <strong>{t('selectCertificate.detail-2')}</strong>{cert.validity}
                  </span>
                </div>
              </div>
            </div>
          ))}
          <div className="form-group mb-0">
            <button className="btn btn-login btn-block" type="submit">{t('selectCertificate.continue-button')}</button>
            <a className="btn link-cancel" type="button" onClick={handleCancel}>{t('selectCertificate.cancel-button')}</a>
          </div>
          {error && (
            <div className="alert-message">
              <p>{error}</p>
            </div>
          )}
        </form>
      </section>
  );
};
